/**
 * Picks a random home-hero title client-side so full-page cache
 * can still serve a single HTML document with varying titles.
 */
class HomeHeroTitles {
	constructor() {
		this.init();
	}

	private init() {
		const elements = document.querySelectorAll<HTMLElement>(
			'[data-home-hero-title][data-random-titles]',
		);

		elements.forEach((el) => {
			const raw = el.getAttribute('data-random-titles');
			if (!raw) return;

			let titles: unknown;
			try {
				titles = JSON.parse(raw);
			} catch {
				return;
			}

			if (!Array.isArray(titles) || titles.length <= 1) return;

			const pick = titles[Math.floor(Math.random() * titles.length)];
			if (typeof pick !== 'string') return;

			el.innerHTML = pick;
		});
	}
}

export default HomeHeroTitles;
